/*global ymaps*/

import zlib  from "pako";
import vt from '@mapbox/vector-tile';
import Protobuf from 'pbf';
import { getGeoCoordsX, getGeoCoordsY, nnTiles } from "./Admin/services/coordsServise";
import { classIdMap, regStatusMap, statusMap } from "./investPropertiesMap";

export const generateInvestClusterBalloonLayout = ({ name, category, voltage, event_time, note, classIdText, statusText, regStatusText }) => ({
    balloonContentHeader: `<h4 class="investobject-header">${name !== '{}' ? name : ""}</h4>`,
    balloonContentBody: [
        `<div class="investobject-description-list">`,
        `<div class="investobject-description"><strong>Категория</strong> <span>${category}</span></div>`,
        classIdText != undefined && `<div class="investobject-description"><strong>Класс</strong> <span>${classIdText}</span></div>`,
        //statusText != undefined && `<div class="investobject-description"><strong>Статус</strong> <span>${statusText}</span></div>`,
        regStatusText != undefined && `<div class="investobject-description"><strong>Назначение</strong> <span>${regStatusText}</span></div>`,
        voltage != undefined && `<div class="investobject-description"><strong>Напряжение</strong> <span>${voltage} кВ</span></div>`,
        //event_time != undefined && `<div class="investobject-description"><strong>Срок окончания работ</strong> <span>${event_time}</span></div>`,
        //note != undefined && `<div class="investobject-description"><strong>Примечание</strong> <span>${note}</span></div>`,
        `</div>`,
    ].filter(Boolean).join(""),
    clusterCaption: `<h4 class="investobject-header">${name}</h4>`
})

export const generateMRSKBalloonLayout = ({ name, category, holder, service, address, service_phone, holder_phone, type, is_customer, start_date, end_date, transformers, existing_load_public, free_capacity_public, capacity_on_contracts, capacity_on_requests, free_capacity_full_public, capacityUnit }) => ({
    balloonContentHeader: `<h4 class="investobject-header">${name !== '{}' ? name : ""}</h4>`,
    balloonContentBody: [
        `<div class="investobject-description-list">`,
        `<div class="investobject-description"><strong>Категория</strong> <span>${category}</span></div>`,
        holder != undefined && `<div class="investobject-description"><strong>Принадлежность / Балансодержатель</strong> <span>${holder}</span></div>`,
        address != undefined && `<div class="investobject-description"><strong>Адрес</strong> <span>${address}</span></div>`,
        service != undefined && `<div class="investobject-description"><strong>Телефон</strong> <span>${service}<br />${service_phone}</span></div>`,
        type === 'ps' && is_customer && holder_phone && `<div class="investobject-description"><strong>Телефон</strong> <span>${holder}</span><br /><span>${holder_phone}</span></div>`,
        start_date != undefined && `<div class="investobject-description"><strong>В эксплуатации</strong> <span>C ${start_date + "г."}${(end_date > (new Date()).getFullYear()) ? ' ( реконструкция: ' + end_date +'г. )':''}</span></div>`,
        `</div>`,
        (type == 'ps' && !is_customer && [transformers, existing_load_public, free_capacity_public, capacity_on_contracts, capacity_on_requests, free_capacity_full_public].some(Boolean) ||
        type !== 'ps' && [transformers, free_capacity_full_public].some(Boolean)) && `<h5 class="investobject-subheader">Мощность</h5><div class="investobject-description-list investobject-description-list--power">`,
        type == 'ps' && !is_customer && transformers && `<div class="investobject-description"><strong>${transformers.replaceAll('+',' + ').replaceAll(',00','')} ${capacityUnit}</strong> <span>Установленная мощность трансформаторов</span></div>`,
        type == 'ps' && !is_customer && existing_load_public && `<div class="investobject-description"><strong>${existing_load_public} ${capacityUnit}</strong> <span>Существующая нагрузка по результатам замерного дня</span></div>`,
        type == 'ps' && !is_customer && free_capacity_public && `<div class="investobject-description"><strong>${free_capacity_public} ${capacityUnit}</strong> <span>Профицит/дефицит мощности по результатам замеров режимного дня</span></div>`,
        type == 'ps' && !is_customer && capacity_on_contracts && `<div class="investobject-description"><strong>${capacity_on_contracts} ${capacityUnit}</strong> <span>Объем мощности по заключенным договорам на технологическое присоединение, находящиеся на исполнении</span></div>`,
        type == 'ps' && !is_customer && capacity_on_requests && `<div class="investobject-description"><strong>${capacity_on_requests} ${capacityUnit}</strong> <span>Объем мощности по заявкам на технологическое присоединение</span></div>`,
        type == 'ps' && !is_customer && free_capacity_full_public && `<div class="investobject-description"><strong>${free_capacity_full_public} ${capacityUnit}</strong> <span>Максимальная мощность, разрешенная при технологическом присоединении для "открытых" центров питания</span></div>`,
        type !== 'ps' && transformers && `<div class="investobject-description"><strong>${transformers.replaceAll('+',' + ').replaceAll(',00','')} ${capacityUnit}</strong> <span>Установленная мощность трансформаторов</span></div>`,
        type !== 'ps' && free_capacity_full_public && `<div class="investobject-description"><strong>${free_capacity_full_public} ${capacityUnit}</strong> <span>Объем свободной мощности с учетом присоединенных потребителей и заключенных договоров на ТП</span></div>`,
        (type == 'ps' && !is_customer && [transformers, existing_load_public, free_capacity_public, capacity_on_contracts, capacity_on_requests, free_capacity_full_public].some(Boolean) ||
        type !== 'ps' && [transformers, free_capacity_full_public].some(Boolean)) && `</div>`,
    ].filter(Boolean).join(""),
    clusterCaption: `<h4 class="investobject-header">${name}</h4>`
})

const featureOptionsByProperties = (properties, options) => {
    if (properties.classId && options.fillVariants && options.fillVariants[properties.classId]) {
        return {
            ...options,
            fillColor: options.fillVariants[properties.classId],
            strokeColor: options.fillVariants[properties.classId],
        }
    }
    return options;
}

export const mapFeatureParams = (properties) => {
    const currentYear = new Date().getFullYear();

    properties.name = properties.NAME || properties.name || undefined;
    properties.status = properties.STATUS || properties.status || undefined;
    properties.reg_status = properties.REG_STATUS || properties.reg_status || undefined;
    properties.event_time = properties.EVENT_TIME || properties.event_time || undefined;
    properties.classId = properties.CLASSID || properties.classid || properties.classId || undefined;
    properties.voltage = properties.VOLTAGE || properties.voltage || undefined;
    properties.note = properties.NOTE || properties.note || undefined;
    properties.statusText = statusMap[properties.status];
    properties.regStatusText = regStatusMap[properties.reg_status];
    properties.classIdText = classIdMap[properties.classId];
    properties.name = properties.name.replace("{}", "") || properties.classIdText || properties.category || "";

    if (properties.event_time && Number(properties.event_time) < currentYear) {
        properties.event_time = `${currentYear + Number(properties.event_time)}`;
    }
    if (properties.event_time === '0' || !properties.event_time) {
        properties.event_time = "Не указано";
    } else {
        properties.event_time = properties.event_time + " г.";
    }
    if (properties.note === "{}") {
        properties.note = undefined;
    }

    properties.hintContent = properties.name;
    properties.balloonContent = properties.name;
    properties = {...properties, ...generateInvestClusterBalloonLayout(properties)}

    return properties;
}

export default function defineLayerWMS() {
    ymaps.modules.define('WMSGeoJsonCollection', [
        'projection.wgs84Mercator',
        'projection.sphericalMercator',
        'projection.Cartesian',
        'util.extend',
        'GeoObjectCollection'
    ], function (provide, wgs84Mercator, sphericalMercator, Cartesian, extend, GeoObjectCollection) {
        var DEFAULT_WMS_PARAMS = {
            service: "WMS",
            request: 'GetMap',
            layers: '',
            styles: '',
            //format: 'application/json;type=geojson',
            format: "application/vnd.mapbox-vector-tile",
            transparent: false,
            version: '1.3.0',
            crs: null, // WMS 1.3.0 only
            srs: null, // WMS 1.1.1 and earlier only
            size: 256,
            // Some servers need correction
            offsetX: 0,
            offsetY: 0,
            projection: sphericalMercator,
            maxZoom: undefined,
            minZoom: undefined
        };
            const MAX_LATITUDE = 85.0511287798
            const R = 6378137;
            const d = Math.PI / 180;
    
            const project = function(latlng) {
    
                var max = MAX_LATITUDE,
                    lat = Math.max(Math.min(max, latlng[0]), -max),
                    sin = Math.sin(lat * d);
    
                return [R * latlng[1] * d, (R * Math.log((1 + sin) / (1 - sin))) / 2];
            }

            function getCrs(projection) {
                switch(true) {
                    case projection === wgs84Mercator:
                    return 'CRS:84';
                    case projection === sphericalMercator:
                    return 'EPSG:3857';
                    case projection instanceof Cartesian:
                    return 'CRS:1';
                }
                return 'EPSG:4326';
            }
    
        function WMSGeoJsonCollection(baseUrl, options) {
            var opts = extend({}, DEFAULT_WMS_PARAMS, options);

            this.collection = new GeoObjectCollection({}, opts.styleOptions);

            this.getTileUrl =  function (tileNumber, tileZoom) {
                if (tileZoom > opts.maxZoom || tileZoom < opts.minZoom) return null;

                var projection = opts.projection;
    
                var pixelBounds = [
                [tileNumber[0] * opts.size, tileNumber[1] * opts.size],
                [(tileNumber[0] + 1) * opts.size, (tileNumber[1] + 1) * opts.size]
                ];
                var bounds = pixelBounds.map(function (pixelPoint) {
                return projection.fromGlobalPixels(pixelPoint, tileZoom);
                });
                
                bounds = bounds.map(function (pixelPoint) {
                    return project(pixelPoint)
                })
                var wmsParams = extend({
                    SERVICE: opts.service,
                    VERSION: opts.version,
                    REQUEST: opts.request,
                    FORMAT: opts.format,
                    LAYERS: opts.layers,
                    WIDTH: opts.width,
                    HEIGHT: opts.height,
                    STYLES: undefined,
                }, {
                    BBOX: [
                        bounds[0][0] + opts.offsetX,
                        bounds[1][1] + opts.offsetY,
                        bounds[1][0] + opts.offsetX,
                        bounds[0][1] + opts.offsetY,
                    ].join(),
                    TRANSPARENT: String(opts.transparent),
                    CRS: opts.crs || getCrs(projection),
                });
                const urlParts = baseUrl.split('?');
                const searchParams = new URLSearchParams(urlParts[1] || undefined);
                Object.keys(wmsParams).filter(param => Boolean(wmsParams[param])).forEach(param => {
                    searchParams.append(param, wmsParams[param])
                })
                return `${urlParts[0]}?${searchParams.toString()}`;
            };

            this.activate = () => {
                if (this.collection.get(0)) return;        
                nnTiles.forEach(this.fetchTile);
            }

            this.addFeatures = (features) => {
                features.forEach(feature => {
                    feature.properties.category = opts.properties.category;
                    feature.properties.icon = opts.properties.icon;
                    feature.properties = mapFeatureParams(feature.properties);
                    const featureOptions = featureOptionsByProperties(feature.properties, opts.styleOptions);

                    switch(feature.geometry.type){
                        case "MultiLineString": {
                            feature.geometry.coordinates.forEach(n => {
                                this.collection.add(new ymaps.Polyline(n.map(this.applyCoords), feature.properties, featureOptions))
                            });
                            break;
                        }
                        case "LineString": {
                            this.collection.add(new ymaps.Polyline(feature.geometry.coordinates.map(this.applyCoords), feature.properties, featureOptions))
                            break;
                        }
                        case "Point": {
                            this.collection.add(new ymaps.Placemark(this.applyCoords(feature.geometry.coordinates), feature.properties, featureOptions))
                            break;
                        }
                        case "MultiPoint": {
                            feature.geometry.coordinates.forEach(n => {
                                this.collection.add(new ymaps.Placemark(n.map(this.applyCoords), feature.properties, featureOptions))
                            });
                            break;
                        }
                        case "Polygon": {
                            this.collection.add(new ymaps.Polygon([feature.geometry.coordinates[0].map(this.applyCoords)], feature.properties, featureOptions))
                            break;
                        }
                        case "MultiPolygon": {
                            feature.geometry.coordinates.forEach(n => {
                                this.collection.add(new ymaps.Polygon([n[0].map(this.applyCoords)], feature.properties, featureOptions))
                            });
                            break;
                        }
                    }
                })
            }

            this.applyCoords = (m) => {
                if (opts.format === 'application/vnd.mapbox-vector-tile') {
                    return [m[1], m[0]];
                } else {
                    return [getGeoCoordsY(m[1]), getGeoCoordsX(m[0])];
                }
            }

            this.fetchTile = async (xyz) => {
                try {
                    const url = this.getTileUrl([xyz.x,xyz.y], xyz.z);
                    if (!url) return;
                    const json = await fetch(this.getTileUrl([xyz.x,xyz.y], xyz.z));
                    if (opts.format === 'application/vnd.mapbox-vector-tile') {
                        const resp = await json.arrayBuffer();
                        const features = this.readMVTTile(xyz, resp);
                        this.addFeatures(features);
                    } else {
                        const resp = await json.json();
                        this.addFeatures(resp.features);
                    }
                } catch(err) {
                    console.log(err);
                }
            }

            this.readMVTTile = (args, buffer) => {
                // handle zipped buffers
                if (buffer[0] === 0x78 && buffer[1] === 0x9C) {
                    buffer = zlib.inflateSync(buffer);
                } else if (buffer[0] === 0x1F && buffer[1] === 0x8B) {
                    buffer = zlib.gunzipSync(buffer);
                }
              
                var tile = new vt.VectorTile(new Protobuf(buffer));
                var layers = args.layer || Object.keys(tile.layers);
              
                if (!Array.isArray(layers))
                    layers = [layers]
              
                const features = [];

                layers.forEach(function (layerID) {
                    var layer = tile.layers[layerID];
                    if (layer) {
                        for (var i = 0; i < layer.length; i++) {
                            var feature = layer.feature(i).toGeoJSON(args.x, args.y, args.z);
                            if (layers.length > 1) feature.properties.vt_layer = layerID;
                            features.push(feature);
                        }
                    }
                });
                return features;
            }
            
            return this;
        }
    
        provide(WMSGeoJsonCollection);
    });

    ymaps.modules.define('LayerWMS', [
        'Layer',
        'projection.wgs84Mercator',
        'projection.sphericalMercator',
        'projection.Cartesian',
        'util.extend',
    ], function (provide, Layer, wgs84Mercator, sphericalMercator, Cartesian, extend) {
        var DEFAULT_WMS_PARAMS = {
        request: 'GetMap',
        layers: '',
        styles: '',
        format: 'image/jpeg',
        transparent: false,
        version: '1.1.1',
        crs: null, // WMS 1.3.0 only
        srs: null, // WMS 1.1.1 and earlier only
        size: 256,
        // Some servers need correction
        offsetX: 0,
        offsetY: 0,
        maxZoom: undefined,
        minZoom: undefined
        };
        const MAX_LATITUDE = 85.0511287798
        const R = 6378137;
        const d = Math.PI / 180;

        const project = function(latlng) {

            var max = MAX_LATITUDE,
                lat = Math.max(Math.min(max, latlng[0]), -max),
                sin = Math.sin(lat * d);

            return [R * latlng[1] * d, (R * Math.log((1 + sin) / (1 - sin))) / 2];
        }

        function getProjection(crs, options) {
        switch(true) {
            case /^(CRS:84|EPSG:4326)$/i.test(crs):
            return wgs84Mercator;
            case /^EPSG:3857$/i.test(crs): // Google, OSM
            return sphericalMercator;
            case /^CRS:1$/i.test(crs): // Cartesian
            return new Cartesian([
                [-options.size, -options.size],
                [+options.size, +options.size]
            ]);
            default:
            throw(new TypeError('Invalid CRS'));
        }
        }
        function getCrs(projection) {
        switch(true) {
            case projection === wgs84Mercator:
            return 'CRS:84';
            case projection === sphericalMercator:
            return 'EPSG:3857';
            case projection instanceof Cartesian:
            return 'CRS:1';
        }
        return 'EPSG:4326';
        }
        function LayerWMS(baseUrl, options) {
        var opts = extend({}, DEFAULT_WMS_PARAMS, options);
        var crs = opts.crs || opts.srs;
        var layer = new Layer('', extend({
            tileTransparent: opts.transparent,
            tileSize: [opts.size, opts.size],
        }, crs && {projection: getProjection(crs, opts)}));

        layer.getTileUrl = function (tileNumber, tileZoom) {
            if (tileZoom > opts.maxZoom || tileZoom < opts.minZoom) return null;
            
            var map = this.getMap();
            var projection = this.options.get('projection', map.options.get('projection'));

            var pixelBounds = [
            [tileNumber[0] * opts.size, tileNumber[1] * opts.size],
            [(tileNumber[0] + 1) * opts.size, (tileNumber[1] + 1) * opts.size]
            ];
            var bounds = pixelBounds.map(function (pixelPoint) {
            return projection.fromGlobalPixels(pixelPoint, tileZoom);
            });
            
            bounds = bounds.map(function (pixelPoint) {
                return project(pixelPoint)
            })
            var wmsParams = extend({}, opts, {
            bbox: [
                bounds[0][0] + opts.offsetX,
                bounds[1][1] + opts.offsetY,
                bounds[1][0] + opts.offsetX,
                bounds[0][1] + opts.offsetY,
            ].join(),
            transparent: String(opts.transparent),
            crs: opts.crs || getCrs(projection),
            srs: opts.srs || getCrs(projection),
            size: `${opts.size},${opts.size}`
            });
            const urlParts = baseUrl.split('?');
            const searchParams = new URLSearchParams(urlParts[1] || undefined);
            Object.keys(wmsParams).filter(param => Boolean(wmsParams[param])).forEach(param => {
                searchParams.append(param, wmsParams[param])
            })
            return `${urlParts[0]}?${searchParams.toString()}`;
        };
        return layer;
        }
    
        provide(LayerWMS);
    });
}